
import { Action } from '@ngrx/store';

export enum ContextActionTypes {
  MODELER_CONTEXT = '[bpmn modeler set context]'
}

export class SetModelerContext implements Action {
  readonly type = ContextActionTypes.MODELER_CONTEXT;

  constructor(public payload: { modelerContext: object }) {
  }
}

export type ModelerContextActions = SetModelerContext;
